export default {
  getServiceAvailability(postalCode) {
    return fetch(`${process.env.NEXT_PUBLIC_REACT_APP_API_URL}/v1/public/partners/mlc_service/${postalCode}`, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => data);
  },
};
